<template>
  <div class="container">
    <div class="navbar_t" v-if="common.wallList.length>0">
      <template v-if="$store.state.common.theme!=3">
          <div
            :class="['navbar_list_cover',activeTab==index ? 'cur' :'']"
            v-for="(item,index) of tabs"
            :key="index"
            @click="tabClick(index)"
          >
            <span>{{item}}</span>
            <i></i>
          </div>
      </template>
      <template v-if="$store.state.common.theme==3">
        <div
          :class="['navbar_list_cover_theme3',activeTab==index ? 'cur' :'']"
          v-for="(item,index) of tabs"
          :key="index"
          @click="tabClick(index)"
        >
          <span>{{item}}</span>
          <i></i>
        </div>
    </template>
    </div>
    <!-- 活动数据列表 -->
    <div class="shop_list" v-show="activeTab==0">
      <scroll
        :data="common.activeList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="common.activeList.length"
      >
        <section
          class="list_item"
          v-for="(item,index) in common.activeList"
          :key="index"
          @click="toDetail(item.actId)"
        >
          <section class="list_item_top">
            <img :src="item.actImg" />
            <button
              :class="[ $store.state.common.theme!=3? 'activity_ing_status' : 'activity_ing_status_theme3',item.statusCN == '已结束'?'status_end':'',item.statusCN=='未开始'?'status_unstart':'']"
            >{{item.statusCN}}</button>
            <section class="actLabel">
              <span v-for="cur in item.actLabel" :key="cur"># {{cur}}</span>
            </section>
          </section>
          <section class="list_item_bottom">
            <section class="bottom_left">
              <h2>{{item.actTitle}}</h2>
              <p class="time">{{item.actBegTime | time}} - {{item.actEndTime | time}}</p>
            </section>
            <section class="bottom_right">
              <span class="free" v-if="item.isFree == 1">免费</span>
              <span class="price" v-else>¥ {{item.actPrice.toFixed(2)}}</span>
            </section>
          </section>
        </section>
      </scroll>
      <no-message v-if="!common.activeList.length && loaded"></no-message>
    </div>
    <!-- 企业墙相关 -->
    <div class="shop_list" v-show="activeTab==1">
      <scroll
        :data="common.wallList"
        :allLoaded="qyqallLoaded"
        @pulldown="qyqloadData"
        @loadUp="qyqloadup"
      >
        <section class="qyqTopView">
          <div :class="[str? 'qyqSreachBg1' :'qyqSreachBg']">
            <img class="Sreach_icon" src="../../assets/images/search.png" />
            <input
              ref="search_inp"
              :class="[str? 'Sreach_inp1' :'Sreach_inp']"
              type="text"
              placeholder="搜索企业名称"
              v-model="str"
              maxlength="20"
            />
            <img
              v-if="str"
              @click="cleanStr()"
              class="Sreach_closeicon"
              src="../../assets/images/btn_clear.png"
            />
          </div>
          <div v-if="str" @click="closeInp()" class="serach_quxiao">取消</div>
        </section>
        <section class="qyqList">
          <div
            class="qyqlist_item"
            v-for="(item,index) in common.wallList"
            :key="index"
            @click="toCompanyDetail(item.companyId)"
          >
            <img :src="item.logo" class="qyqlist_item_top" v-if="item.logo" />
            <img src="../../assets/images/img_company_wall.jpg" class="qyqlist_item_top" v-else />
            <span class="qyqlist_item_span1">{{item.companyName}}</span>
            <span class="qyqlist_item_span2">{{item.address}}</span>
          </div>
        </section>
      </scroll>
      <no-message v-if="!common.wallList.length && qyqloaded"></no-message>
    </div>
    <nav-bar :tab="1"></nav-bar>
  </div>
</template>

<script>
import {
  getActiveListByMarketId,
  getCompanyWallsByMarketId
} from "../../utils/api";
import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import util from "../../utils/util";
import NavBar from "../../components/navbar";
import { mapState, mapActions } from "vuex";
export default {
  name: "activityList",
  components: {
    NavBar,
    NoMessage,
    Scroll
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  watch: {
    str() {
      this.companyName = this.str;
      this.qyqpageNo = 1;
      this.qyqdataList = [];
      this.qyqallLoaded = false;
      this.getCompanyWallsByMarketId();
    }
  },
  filters: {
    time(val) {
      return util.formatTime(new Date(val), 6);
    }
  },
  data() {
    return {
      tabs: ["活动", "企业墙"],
      hasqy: false,
      activeTab: 0,
      dataList: [],
      pageNo: 1,
      pageSize: 10,
      allLoaded: false, // 可以进行上拉
      loaded: false,
      //企业墙相关
      str: "",
      companyName: "",
      qyqallLoaded: false,
      qyqloaded: false,
      qyqisLoding: false,
      qyqdataList: [],
      qyqpageNo: 1
    };
  },
  created() {
    if(this.$route.query.come == 'wall'){
      this.activeTab = 1
    }
    this.loadData()
    // if(this.common.activeList.length<=0){
    //   this.getActiveListByMarketId();
    // }
    // if(this.common.wallList.length <=0){
    //   this.getCompanyWallsByMarketId();
    // }
    this.qyqpageNo =1
    this.getCompanyWallsByMarketId()
  },
  methods: {
    ...mapActions(['getActiveList','getWallList']),
    tabClick(index) {
      this.activeTab = index;
    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getActiveListByMarketId();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading();
      this.getActiveListByMarketId();
    },
    //   获取活动列表数据
    getActiveListByMarketId() {
      util.showLoading();
      this.allLoaded = false;
      let params = {
        marketId: this.common.marketInfo.id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        actName: "", // 搜索
        actType: "1", // 2是商业的活动
        userId: this.common.userId
      };
      getActiveListByMarketId(params, {
        cityId: this.common.marketInfo.cityId,
        userId: this.common.userId
      }).then(res => {
        console.log(res);
        this.loaded = true;
        util.hideLoading();
        if (res.res.code === 10000) {
          let data = res.body.activeList;
          data.forEach(item => {
            if (item.actLabel) {
              item.actLabel = item.actLabel.split(";");
            }
          });
          if (data.length !== 10) {
            this.allLoaded = true; // 若数据已全部获取完毕
          }
          if (this.pageNo === 1) {
            this.getActiveList(data)
          } else {
            this.getActiveList([...this.common.activeList,...data])
          }
        }
      });
    },
    // 活动详情
    toDetail(id) {
      // var url ='/activitySuccess?isVerify='+1
      // var url ='/parkingPaySuccess?id=1316&parkHeaderId=38'
      //         this.$router.push({
      //           path: url
      //         });
      var url = `/activityDetails/${id}`;
      
      if(this.common.marketInfo.id){
         url =url +"?marketId="+this.common.marketInfo.id
         if(this.common.cityId){
            url =url +"&cityId="+this.common.cityId
         }
      }
     
      this.$router.push(url);
    },
    //获取企业墙列表数据
    getCompanyWallsByMarketId() {
      // let self = this;
      if (this.qyqisLoding) {
        return;
      }
      this.qyqisLoding = true;
      if (this.activeTab == 1) {
        util.showLoading();
      }
      let params = {
        marketId: this.common.marketInfo.id,
        companyName: this.companyName,
        pageNo: this.qyqpageNo,
        pageSize: 10
      };
      getCompanyWallsByMarketId(params, {
        cityId: this.common.marketInfo.cityId,
        userId: this.common.userId
      }).then(res => {
        console.log(res);
        this.qyqisLoding = false;
        this.qyqloaded = true;
        util.hideLoading();
        if (res.res.code === 10000) {
          let data = res.body.companyWallList;
          if (data.length > 0) {
            this.hasqy = true;
          }
          if (data.length !== 10) {
            this.qyqallLoaded = true; // 若数据已全部获取完毕
          }
          if (this.qyqpageNo === 1) {
            this.getWallList(data)
          } else {
            this.getWallList([...this.common.wallList,...data])
          }
        }
      });
    },

    // 上拉加载
    qyqloadup() {
      if (this.qyqallLoaded) {
        return;
      }
      this.qyqpageNo++;
      this.getCompanyWallsByMarketId();
    },
    // 下拉刷新
    qyqloadData() {
      this.qyqpageNo = 1;
      this.qyqallLoaded = false;
      this.getCompanyWallsByMarketId();
    },
    cleanStr() {
      this.str = "";
      this.companyName = "", this.qyqpageNo = 1;
      this.qyqdataList = [];
      this.qyqallLoaded = false;
      // this.changeSearchWord = true
      this.getCompanyWallsByMarketId();
    },
    closeInp() {
      this.str = "";
      this.companyName = "", this.qyqpageNo = 1;
      this.qyqdataList = [];
      this.qyqallLoaded = false;
      this.getCompanyWallsByMarketId();
      this.$refs.search_inp.blur();
    },
    // 企业墙详情
    toCompanyDetail(id) {
      if(this.common.userId){
        this.$router.push(`/companyDetail/${id}`);
      }else{
        this.$router.push({
          path:'/login',
          query:{
            Rurl:`/companyDetail/${id}`
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  .flex(column);
  .shop_list {
    flex: 1;
    height: 500px;
    padding-bottom: 1rem;
  }
}
.navbar_t {
  .flex();
  justify-content: center;
  width: 100%;
  height: 88px;
  margin: 0 auto;
  background: #ffffff;
  box-shadow:0px 4px 16px 0px rgba(0,0,0,0.06);
  .navbar_list_cover {
    .flex(column);
    text-align: center;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding-top: 20px;
    span {
      height: 48px;
      line-height: 48px;
      color: @color9;
      font-size:32px;
    }
    i {
      width: 32px;
      height: 6px;
      background: #ffffff;
    }
    &.cur {
      span {
        color: @color17;
        font-weight: bold;
      }
      i {
        background: @color17;
      }
    }
  }
  .navbar_list_cover_theme3{
    .flex(column);
    text-align: center;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding-top: 20px;
    span {
      height: 48px;
      line-height: 48px;
      color: @color9;
      font-size:32px;
    }
    i {
      width: 32px;
      height: 6px;
      background: #ffffff;
    }
    &.cur {
      span {
        color: #9a8162;
        font-weight: bold;
      }
      i {
        background: #9a8162;
      }
    }

  }
}
// .shop_list {
//   height: 100vh;
//   padding-bottom: 1rem;
//   box-sizing: border-box;
//   overflow: hidden;
// }
.list_item {
  margin: 0.2rem;
  background: #fff;
  overflow: hidden;
}
.list_item_top {
  height: 4.72rem;
  width: 100%;
  position: relative;
  img {
    display: block;
    width: 100%;
    height: 4.72rem;
  }
  .activity_ing_status {
    display: block;
    width: 1rem;
    height: 0.44rem;
    position: absolute;
    top: 0.26rem;
    background: linear-gradient(
      270deg,
      rgba(125, 0, 255, 1) 0%,
      rgba(0, 55, 255, 1) 100%
    );
    left: 0.2rem;
    text-align: center;
    line-height: 0.44rem;
    font-size: 0.28rem;
    color: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    border-radius: 0.04rem;
  }
  .activity_ing_status_theme3{
      display: block;
      width: 1rem;
      height: 0.44rem;
      position: absolute;
      top: 0.26rem;
      background: #eec543;
      left: 0.2rem;
      text-align: center;
      line-height: 0.44rem;
      font-size: 0.28rem;
      color: #000000;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      border-radius: 0.04rem;

  }
  .status_end {
    background: #999;
  }
  .status_unstart {
    background: #ff7e1e;
  }
  .actLabel {
    position: absolute;
    bottom: 0.2rem;
    left: 0;
    right: 0.2rem;
    height: 0.4rem;
    .flex();
    flex-direction: row;
    z-index: 2;
    justify-content: flex-end;
    span {
      display: block;
      height: 0.4rem;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 0.04rem;
      line-height: 0.4rem;
      padding: 0 0.12rem;
      margin-left: 0.1rem;
      font-size: 0.24rem;
      color: #fff;
    }
  }
}
.list_item_bottom {
  .flex();
  justify-content: space-between;
  padding: 0.28rem 0.2rem;
  position: relative;
  .bottom_left {
    width: 5.2rem;
    h2 {
      height: 0.44rem;
      font-size: 0.32rem;
      font-weight: bold;
      color: #333;
      line-height: 0.44rem;
      .textOver(100%);
    }
    p {
      height: 0.4rem;
      font-size: 0.28rem;
      color: #999;
      line-height: 0.4rem;
      padding-left: 0.4rem;
      background: url("../../assets/images/time.png") left center no-repeat;
      background-size: 0.28rem 0.28rem;
      margin-top: 0.08rem;
    }
  }
  .bottom_right {
    position: absolute;
    top: 0.28rem;
    right: 0.28rem;
    white-space: nowrap;
    background: #fff;
    .free {
      height: 0.44rem;
      font-size: 0.28rem;
      color: rgba(51, 51, 51, 1);
      line-height: 0.4rem;
    }
    .price {
      height: 0.44rem;
      font-size: 0.32rem;
      color: rgba(51, 51, 51, 1);
      line-height: 0.44rem;
    }
  }
}

.qyqTopView {
  width: 100%;
  height: 120px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: row;
}
.qyqSreachBg {
  width: 694px;
  height: 68px;
  margin-left: 28px;
  margin-top: 26px;
  background: rgba(244, 244, 244, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
}
.qyqSreachBg1 {
  width: 602px;
  height: 68px;
  margin-left: 28px;
  margin-top: 26px;
  background: rgba(244, 244, 244, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
}
.Sreach_icon {
  margin-left: 14px;
  margin-top: 12px;
  width: 44px;
  height: 44px;
  display: flex;
}
.Sreach_inp {
  margin-left: 16px;
  margin-top: 14px;
  width: 600px;
  height: 40px;
  font-size: 28px;
  background: rgba(244, 244, 244, 1);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  display: flex;
}

.Sreach_inp1 {
  margin-left: 16px;
  margin-top: 14px;
  width: 472px;
  height: 40px;
  font-size: 28px;
  background: rgba(244, 244, 244, 1);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  display: flex;
}

.Sreach_closeicon {
  margin-top: 12px;
  width: 44px;
  height: 44px;
  display: flex;
}

.serach_quxiao {
  margin-top: 42px;
  margin-left: 32px;
  height: 40px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.qyqList {
  padding:0 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.qyqlist_item {
  width:345px;
  height: 345px;
  margin-bottom:20px;
  border:1px solid #eaeaea;
  border-radius:4px;
  box-sizing:border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
}

.qyqlist_item_top {
  margin-top: 30px;
  width: 160px;
  height: 160px;
  display: flex;
  object-fit:contain;
  flex-direction: column;
}
.qyqLogo {
  width: 160px;
  height: 160px;
  display: flex;
}

.qyqlist_item_span1 {
  width: 90%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #333333;
  font-size: 28px;
  margin:28px auto 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qyqlist_item_span2 {
  width: 90%;
  height: 34px;
  text-align: center;
  line-height: 34px;
  color: #999999;
  font-size: 24px;
  margin:8px auto 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
